import { useMemberMutations } from "@app/entities/member/mutations";
import { T_MemberAvailability } from "@app/entities/member/types";
import { useMember } from "@app/providers/MemberContextProvider";
import Form from "antd/lib/form";
import notification from "antd/lib/notification";
import { useRef } from "react";

const DEBOUNCE_TIME = 500;

export const useMemberAvailabilityFormLoader = () => {
  const { selectedMember, isMembersPending } = useMember();
  const { updateMemberAvailability, isMutationPending } = useMemberMutations();

  // Use ref to set a timer for debouncing
  const timeoutRef = useRef<NodeJS.Timeout | number | null>(null);
  const [memberAvailabilityForm] = Form.useForm();

  const debouncedUpdateAvailability = async ({
    key,
    value,
  }: {
    key: keyof T_MemberAvailability;
    value: string | boolean;
  }) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(async () => {
      if (!selectedMember) return;
      if (key === "rangeInMiles" && Number(value) > 50) {
        return notification.error({
          description: "Range in miles cannot exceed 50.",
          title: "Error",
        });
      }
      if (key === "elevationMaximum" && Number(value) > 50) {
        return notification.error({
          description: "Elevation maximum cannot exceed 50.",
          title: "Error",
        });
      }
      updateMemberAvailability(
        { entityId: selectedMember.entityId, availability: { [key]: value } },
        {
          onSuccess: () => memberAvailabilityForm.resetFields(),
        },
      );
    }, DEBOUNCE_TIME);
  };

  const handleUpdateMemberAvailability = (
    availability: Partial<T_MemberAvailability>,
  ) => {
    if (!selectedMember) return;
    updateMemberAvailability({ entityId: selectedMember.entityId, availability });
  };

  const isLoading = isMutationPending || isMembersPending;
  return {
    isLoading,
    memberAvailabilityForm,
    debouncedUpdateAvailability,
    updateMemberAvailability: handleUpdateMemberAvailability,
  };
};
